import styled, {css} from 'styled-components';

import type {StyledProps} from './types';

import {ms} from '../../styles/normalizeSize';
import {getColor, getFontWeight, getRem, square} from '../../styles/utils';
import {platform} from '../../utils/platform';
import {Clickable} from '../Clickable';
import {Text} from '../Text';
import {TextInput} from '../TextInput';
import {View} from '../View';

export const Container = styled(Clickable)`
  position: relative;
  box-sizing: border-box;
  width: 100%;
`;

export const HiddenInput = styled(TextInput)<{size: number}>`
  opacity: 0;
  position: absolute;
  inset: 0;
  z-index: 1;
  height: ${p => p.size}px;
`;

export const InputsContainer = styled(View)<StyledProps>`
  display: flex;
  flex-direction: row;
  height: ${p => p.size!}px;

  ${p =>
    !p.spacing &&
    css`
      align-items: center;
      justify-content: space-between;
    `}

  ${p =>
    p.spacing &&
    css`
      justify-content: center;
      gap: ${p.spacing}px;
    `}

  ${p =>
    p.disabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}
`;

type InputViewStyledProps = StyledProps & {
  index: number;
  isActive: boolean;
  isFilled: boolean;
  isFocused: boolean;
};

export const InputView = styled(View)<InputViewStyledProps>`
  ${p =>
    square(p.size!, {
      ms: false,
    })}
  border: 1px solid ${getColor('border2')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${ms(8)};

  ${p =>
    p.isFilled &&
    css`
      border-color: ${getColor('global1')};
    `}

  ${p =>
    p.isActive &&
    p.isFocused &&
    css`
      border-bottom-width: ${ms(3)};
      border-color: ${getColor('global1')};
    `}
`;

export const InputText = styled(Text)<StyledProps>`
  font-size: ${p => getRem(p.size! * 0.45)};
  font-weight: ${getFontWeight('semibold')};
  user-select: none;

  ${platform.isNative &&
  css`
    line-height: undefined;
  `}

  ${platform.isWeb &&
  css`
    line-height: normal;
  `}
`;
